import React, { useEffect, useState} from 'react';
import { /*Dropdown, DropdownToggle, DropdownMenu, DropdownItem,*/ Button } from 'reactstrap';
import {Link, useHistory} from 'react-router-dom';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { logout } from 'redux/modules/auth/action';
import { ListGroup, ListGroupItem } from 'reactstrap';

const MobileTabMenu = ({ auth, logout, toggler, ...props }) => {
    let history = useHistory();

    const [active, setActive]= useState([])
    useEffect(() => {
        let mobileAuthTabs = [
            // { name: 'Home', link: '/home' },
            // { name: 'Search', link: '/search' },
            { name: 'Fetches', link: '/feeds/fetches' },
            { name: 'Ticker', link: '/ticker' },
            { name: 'Settings', link: '/settings' },
            { name: 'Logout', link: '/' },
        ]
        if(auth.permissions && auth.permissions.includes('search')) {
            mobileAuthTabs.splice(0, 0, {name: 'Searches', link: '/saved-searches'})
        }
        if(auth.permissions && auth.permissions.includes('entity')) {
            mobileAuthTabs.splice(0, 0, { name: 'Add entity', link: '/add-entity' })
            mobileAuthTabs.splice(0, 0, { name: 'Home', link: '/home' })
        }
        /*if(auth.permissions && auth.permissions.length > 0) {
            mobileAuthTabs.splice(3, 0, { name: 'Create Fetch', link: '/main/globe' })
        }*/
        if(!auth.isSingleUser) {
            mobileAuthTabs.splice(3, 0, { name: 'Users', link: '/users' })
        }
        
        setActive(mobileAuthTabs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const notActive = [
        //{ name: 'How it works', link: '/about', },
        //{ name: 'Solutions', link: '/solutions' },
        //{ name: 'Pricing', link: '/pricing', },
    ];

    const menu = auth.isAuthenticated ? active : notActive;

    const handleChangePage = (item) => {
        if (item.name === 'Logout') {
            history.push(item.link);
            toggler(false);
            logout();
            return;
        }

        toggler(false);
        history.push(item.link);
    };

    return (
        <div
            className="userMenuMobAndTab d-flex flex-column"
            style={{
                zIndex: 99999999,
                position: 'absolute',
                top: '55px',
                left: '0px',
                width: '100%',
                padding: '10px',
                background: '#f9fafb',
            }}
        >
            {auth.isAuthenticated === false && (
                <div className="d-flex justify-content-around align-items-center" style={{ width: '100%', marginBottom: '10px' }}>
                    <Link style={{ width: '33%' }} to="/signin">
                        <Button onClick={() => toggler(false)} className="w-100 typical-button">
                            Sign In
                        </Button>{' '}
                    </Link>
                    <a href={new URL(window.location.href).hostname  === 'app.newsfetch.io' ? 'https://newsfetch.io/pricing/' : 'https://web2rss-tst.dataprodev.com/pricing/'} style={{ width: '33%' }}>
                        <Button
                            onClick={() => toggler(false)}
                            className="w-100 calltoaction-button"
                        >
                            Sign Up
                        </Button>
                    </a>
                </div>
            )}
            <ListGroup className="align-self-start w-100">
                {menu.map((item) => {
                    return (
                        <ListGroupItem style={{ color: '#0f1c52' }} active={item.name === 'Sign Up' && true} key={item.name} onClick={() => handleChangePage(item)} action>
                            {item.name}
                        </ListGroupItem>
                    );
                })}
            </ListGroup>
        </div>
    );
};

const mapStateFromProps = (state) => ({
    auth: state.auth,
});

export default connect(mapStateFromProps, { logout })(withRouter(MobileTabMenu));
